import { combineReducers } from "redux";
import { reducer as reduxForm } from "redux-form";
import { connectRouter } from "connected-react-router";
import SettingReducer from "./SettingReducer";
import FaqReducer from "./FaqReducer";
import PrivilegeReducer from "./PrivilegeReducer";
import CategoryReducer from "./CategoryReducer";
import WishListReducer from "./WishListReducer";
import AuthReducer from "./AuthReducer";
import WalletReducer from "./WalletReducer";
import NotifyReducer from "./NotifyReducer";
import LanguageReducer from "./LanguageReducer";
import RedeemReducer from "./RedeemReducer";
import ShopcodeReducer from "./ShopcodeReducer";
import CouponReducer from "./CouponReducer";
import ForgotPasswordReducer from "./ForgotPasswordReducer";
const createRouteReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    form: reduxForm,
    setting: SettingReducer,
    faq: FaqReducer,
    privilege: PrivilegeReducer,
    category: CategoryReducer,
    wishList: WishListReducer,
    auth: AuthReducer,
    wallet: WalletReducer,
    notify: NotifyReducer,
    language: LanguageReducer,
    redeem: RedeemReducer,
    shopcode: ShopcodeReducer,
    coupon : CouponReducer,
    forgotPassword  : ForgotPasswordReducer
  });
export default createRouteReducer;
